  <!-- 报表管理 -->
<template>
  <div class="ReportManager">
    <div class="l_div">
      <div class="l_iem" v-for="(itemp, indexp) in list" :key="indexp">
        <aside>{{ itemp.name }}</aside>
        <ul>
          <li
            class="litext"
            v-for="(item, index) in itemp.child"
            :key="index"
            @click="clickMute(item)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  mixins: [],
  components: {},
  data() {
    return {
      list: [
        // {
        //   name: "报表2",
        //   child: [
        //     // {
        //     //   menuName: "通用页面",
        //     //   jumpUrl: "/ReportManager/PublicQuotationPages",
        //     // },
        //     {
        //       menuName: "应收账款明细",
        //       jumpUrl: "/FM/ReportManager/AccountsReceivableDetails",
        //     },
        //     {
        //       menuName: "客户应收账款情况表",
        //       jumpUrl:
        //         "/FM/ReportManager/CustomerAccountsReceivableStatusTable",
        //     },
        //     {
        //       menuName: "承运商应付账款情况表",
        //       jumpUrl: "/FM/ReportManager/CarrierAccountsPayableStatusTable",
        //     },
        //     {
        //       menuName: "报销应付统计",
        //       jumpUrl: "/FM/ReportManager/ReimbursementPayableStatistics",
        //     },
        //     {
        //       menuName: "运单损益表",
        //       jumpUrl: "/FM/ReportManager/WaybillIncomeStatement",
        //     },
        //     {
        //       menuName: "月应收汇总",
        //       jumpUrl: "/FM/ReportManager/MonthlyAccountsReceivableSummary",
        //     },
        //     {
        //       menuName: "客户发货数据看板",
        //       jumpUrl: "/FM/ReportManager/CustomerShipmentDataDashboard",
        //     },
        //     {
        //       menuName: "客服统计",
        //       jumpUrl: "/FM/ReportManager/CustomerServiceStatistics",
        //     },
        //     {
        //       menuName: "操作数据统计报表（运营）",
        //       jumpUrl:
        //         "/FM/ReportManager/OperationalDataStatisticsReportOperations",
        //     },
        //     {
        //       menuName: "运单成本明细表",
        //       jumpUrl: "/FM/ReportManager/WaybillCostDetails",
        //     },
        //     {
        //       menuName: "运营操作人员明细表",
        //       jumpUrl: "/FM/ReportManager/ListOfOperatingPersonnel",
        //     },
        //     {
        //       menuName: "系统操作统计",
        //       jumpUrl: "/FM/ReportManager/SystemOperationStatistics",
        //     },
        //   ],
        // },
        // {
        //   name: "报表1",
        //   child: [
        //     {
        //       menuName: "客户损益表",
        //       jumpUrl: "/FM/CustomPL",
        //     },
        //     {
        //       menuName: "运单损益表",
        //       jumpUrl: "/FM/TransportPL",
        //     },
        //     {
        //       menuName: "车辆损益表",
        //       jumpUrl: "/FM/VehiclePL",
        //     },
        //     {
        //       menuName: "部门损益表",
        //       jumpUrl: "/FM/DepartPL",
        //     },
        //     {
        //       menuName: "司机押运费用",
        //       jumpUrl: "/FM/DriverEscort",
        //     },
        //     {
        //       menuName: "装卸费用清单",
        //       jumpUrl: "/FM/StevedoreCost",
        //     },
        //     {
        //       menuName: "运单车费分摊清单",
        //       jumpUrl: "/FM/TransportFare",
        //     },
        //     {
        //       menuName: "应收账款明细",
        //       jumpUrl: "/FM/BillsDetailed",
        //     },
        //     {
        //       menuName: "外发应付账款明细",
        //       jumpUrl: "/FM/OutboundDetailed",
        //     },
        //     {
        //       menuName: "外请应付账款明细",
        //       jumpUrl: "/FM/InviteDetailed",
        //     },
        //     {
        //       menuName: "车辆配载",
        //       jumpUrl: "/FM/VehicleStowage",
        //     },
        //   ],
        // },
      ],
    };
  },
  updated() {},
  created() {},
  mounted() {
    this.getData();
  },
  // beforeRouteLeave(to, from, next) {
  //   to.meta.title = "报表明细"; // 根据需要动态修改下一个路由的标题
  //   next();
  // },
  methods: {
    clickMute(item) {
      let url = item.jumpUrl || "/ReportManager/PublicQuotationPages";

      // this.$router.beforeEach((to, from, next) => {
      //   to.meta.title = item.title; // 在全局的beforeEach导航守卫中设置整个页面的标题
      //   next();
      // });

      this.$router.push({
        path: url,
        query: {
          oldNumber: item.oldNumber || "",
          title: item.title || "",
        },
      });
    },

    getData() {
      this.$API
        .getReportList({
          mainReportTypeId: "",
          title: "",
        })
        .then((res) => {
          let datas = res.data.result || [];

          // 使用 reduce 方法进行分组
          const groupedObject = datas.reduce((acc, obj) => {
            const typeId = obj.typeId;
            if (!acc[typeId]) {
              acc[typeId] = [];
            }
            acc[typeId].push(obj);
            return acc;
          }, {});

          let arrs = [];
          for (var key in groupedObject) {
            let obj = {
              name: groupedObject[key][0].typeName,
              child: groupedObject[key],
            };
            arrs.push(obj);
          }

          this.list = arrs;
        });
    },
  },
};
</script>
<style scoped lang="less">
.ReportManager {
  .l_div {
    display: flex;
    padding: 30px 15px;
    flex-wrap: wrap;
    .l_iem {
      margin-left: 30px;
      width: 240px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 2px #ddd;
      padding: 0 0 20px 0;
      border-radius: 6px;
      min-width: 220px;
      margin-bottom: 20px;

      aside {
        color: #fff;
        background: #ef7c1b;
        padding: 8px 16px;
        border-radius: 2px;
        font-size: 16px;
      }
      ul {
        padding: 0;
        margin: 0;
        margin-left: 16px;
        li {
          padding: 0;
          margin: 0;
          list-style-type: none;
          color: #333;
          margin-top: 12px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            color: #2962fc;
          }
        }
        .litext {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
                          